import React, {useState, useEffect} from "react";



export default function EditPanelInputSelectWithChangeFunction({thisRef, options, changeFunction}){
	
	const thisStyle = {
		display:"flex",
		width:"313px",
		height:"32px",
		minHeight:"20px",
		border:"1px solid #999",
		color:"black",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"4px",
		fontSize:"12px",
		fontFamily:"helvetica"
	};

	
	const optionDisplay = options.map((item, index) => 
		<option value={item.value}>
				{item.text}
			</option>
	);
	
	const handleChange = () => {
		if(changeFunction){
			changeFunction();
		}
	};
	
	return (
		<select style={thisStyle} ref={thisRef} onChange={handleChange}>
			<option value="-100">Select</option>
			{optionDisplay}
		</select>
	);
}